import React, { useEffect, useRef, useState } from 'react'
import BlockTitle from '../common/BlockTitle'
// import classnames from 'classnames'
import { calculateStickyLimit, Sticky, Range } from '../common/Stiky'
import ScrollElememt from '../../../components/ScrollElement'
import useRandomId from '../../../hooks/useRandomId'
import './style.scss'

type ConfidenceLimits = [Range, Range]

const Confidence: React.FC = () => {
  const $containerRef = useRef<HTMLDivElement>(null)
  const [$container, set$container] = useState<HTMLDivElement | null>(null)
  const [$title, set$title] = useState<HTMLDivElement | null>(null)
  // const stickies = useMemo(() => {
  //   const ret: HTMLElement[] = []
  //   if ($title) {
  //     ret.push($title)
  //   }
  //   return ret
  // }, [$title])
  // const limits = useMemo<HighlightsLimits | null>
  const [limits, setLimits] = useState<ConfidenceLimits | null>(null)
  const titleOnceKey = useRandomId()

  useEffect(() => {
    if (!$container || !$title) return
    if (limits) return
    setLimits(calculateStickyLimit($container, [$title]) as ConfidenceLimits)
  }, [limits, $container, $title])

  useEffect(() => {
    set$container($containerRef.current)
  }, [])

  return (
    <div id="confidence" ref={$containerRef}>
      <Sticky range={limits?.[0]} el={$title} zIndex={101}>
        <BlockTitle
          title="Confidence & Security"
          getRef={(r) => set$title(r)}
          onceKey={titleOnceKey}
        />
      </Sticky>
      <div className="content container md">
        <ScrollElememt className="part" enterClassName="enter" enterOffset={50}>
          {
            "DeFi's journey from prosperity to depression is essentially the journey from abundant liquidity to stagnated liquidity. When "
          }
          <span className="highlight">issues</span>
          {
            ' arise from the financial market itself or its participants, we will see a '
          }
          <span className="highlight">domino effect</span>
          {' in on-chain economy projects.'}
        </ScrollElememt>
        <ScrollElememt className="part" enterClassName="enter" enterOffset={50}>
          {
            "The frequent occurrence of blockchain hacking incidents is reducing users' confidence in on-chain funds’ security, which then affects the liquidity of on-chain funds."
          }
        </ScrollElememt>
        <ScrollElememt className="part" enterClassName="enter" enterOffset={50}>
          {
            'SandBags is committed to solving on-chain security issues, enhancing user confidence, and ultimately driving the development and prosperity of Web3 finance.'
          }
        </ScrollElememt>
      </div>
    </div>
  )
}

export default Confidence
